import { useNavigate } from 'react-router-dom';
import { FaPlay } from 'react-icons/fa';
import { QUESTION_COUNT } from '../data/questions.js';

// A free quiz category tile: gradient "game art", title, and Play. No prize
// pools, entry fees, live badges, player counts or winner countdowns — it's a
// free, for-fun trivia game, so we don't fabricate a real-money contest.
export default function CategoryCard({ cat }) {
  const navigate = useNavigate();

  return (
    <div className="group surface-card rounded-3xl overflow-hidden flex flex-col transition-all duration-200 hover:-translate-y-1.5 hover:shadow-[0_22px_45px_-15px_rgba(76,29,149,0.45)]">
      {/* Game art thumbnail */}
      <div
        className={`relative h-28 sm:h-32 bg-gradient-to-br ${cat.gradient} flex items-center justify-center overflow-hidden`}
      >
        <div className="absolute inset-0 halftone opacity-30" />
        <div className="absolute inset-0 diag-shine" />
        <div className="absolute w-24 h-24 rounded-full bg-white/25 blur-2xl" />
        <span className="relative text-5xl sm:text-6xl drop-shadow-lg transition-transform duration-200 group-hover:scale-110">
          {cat.emoji}
        </span>
        <span className="absolute top-2.5 left-2.5 text-[10px] font-black uppercase tracking-wide text-white bg-black/25 backdrop-blur rounded-full px-2.5 py-1">
          Free
        </span>
      </div>

      {/* Body */}
      <div className="p-4 flex flex-col flex-1">
        <h3 className="text-base font-black text-slate-900 leading-tight truncate">
          {cat.title}
        </h3>
        <p className="mt-1 text-xs font-bold text-slate-400">
          {QUESTION_COUNT} quick questions · trivia
        </p>

        <div className="mt-auto pt-4 flex items-center justify-end">
          <button
            onClick={() => navigate(`/play?cat=${cat.id}`)}
            className="btn-3d flex items-center gap-1.5 px-5 py-2 rounded-xl text-xs font-black uppercase tracking-wide bg-brand hover:bg-brand-dark text-white"
          >
            <FaPlay className="text-[10px]" /> Play
          </button>
        </div>
      </div>
    </div>
  );
}
